// The path of each page. All the links and redirects use these.
// A `*_PATTERN` is the same path with named params, as the route table takes it.

const id = encodeURIComponent;

export const LOGIN_PATH = '/login';

export const DASHBOARD_PATH = '/dashboard';

export const SETTINGS_TABS = ['profile', 'organization', 'users'] as const;
export type SettingsTab = (typeof SETTINGS_TABS)[number];

export const SETTINGS_PATH = '/settings';

export const settingsPath = (tab: SettingsTab) => `${SETTINGS_PATH}?tab=${tab}`;

/** The steps of a campaign, in the order the sidebar lists them. Each is a path segment. */
export const CAMPAIGN_SECTIONS = [
  'overview',
  'brief',
  'platforms',
  'create',
  'quality',
  'setup',
  'publishing',
  'library',
] as const;
export type CampaignSection = (typeof CAMPAIGN_SECTIONS)[number];

export const CAMPAIGNS_PATH = '/campaigns';

const campaignRoute = (campaignId: string) => `${CAMPAIGNS_PATH}/${campaignId}`;

export const CAMPAIGN_PATTERN = campaignRoute(':campaignId');

export const CAMPAIGN_CREATE_PATH = `${campaignRoute('new')}/brief`;

export const campaignSectionPath = (campaignId: string, section: CampaignSection) =>
  `${campaignRoute(id(campaignId))}/${section}`;

export const campaignSectionPattern = (section: CampaignSection) => `${CAMPAIGN_PATTERN}/${section}`;

export const BRANDS_PATH = '/brand-hub';

const brandRoute = (slug: string) => `${BRANDS_PATH}/brand/${slug}`;
const productImportRoute = (slug: string) => `${brandRoute(slug)}/products/import`;
const productImportsRoute = (slug: string) => `${brandRoute(slug)}/products/imports`;

export const BRAND_PATTERN = brandRoute(':brandSlug');
export const BRAND_TAB_PATTERN = `${BRAND_PATTERN}/:tab`;
export const PRODUCT_IMPORT_PATTERN = productImportRoute(':brandSlug');
export const PRODUCT_IMPORTS_PATTERN = productImportsRoute(':brandSlug');

export const BRAND_CREATE_PATH = brandRoute('new');

export const brandPath = (slug: string) => brandRoute(id(slug));

export const brandTabPath = (slug: string, tab: string) => `${brandPath(slug)}/${tab}`;

export const productImportPath = (slug: string) => productImportRoute(id(slug));

/** The history of every import. Naming one opens it on that record. */
export const productImportsPath = (slug: string, importId?: string) =>
  `${productImportsRoute(id(slug))}${importId ? `?import=${id(importId)}` : ''}`;

export const TEMPLATES_PATH = `${BRANDS_PATH}/templates`;

export const SAVED_ELEMENTS_PATH = `${BRANDS_PATH}/saved-elements`;

export const TEMPLATE_CREATE_PATH = `${TEMPLATES_PATH}/new`;

const templateRoute = (templateId: string) => `${TEMPLATES_PATH}/${templateId}`;
const templateEditorRoute = (templateId: string) => `${templateRoute(templateId)}/editor`;

export const TEMPLATE_PATTERN = templateRoute(':templateId');
export const TEMPLATE_EDITOR_PATTERN = templateEditorRoute(':templateId');

export const templatePath = (templateId: string) => templateRoute(id(templateId));

/** The full-screen canvas. Only a template authored in the editor has one. */
export const templateEditorPath = (templateId: string) => templateEditorRoute(id(templateId));
